module.exports = __webpack_public_path__ + "img/Wp_2085.865db8e9.png";